/* eslint-disable indent */
import React from "react";
import "../animations/animate.css";
import AnimatedBody from "../animations/AnimatedBody";
import AnimatedTitle from "../animations/AnimatedTitle";

const About = () => {
  return (
    <section
      className="relative z-10 w-full items-center justify-center overflow-hidden bg-[#0E1016] bg-cover bg-center pb-36 pt-16 md:pb-44 md:pt-20 lg:pb-56 lg:pt-20"
      id="about"
    >
      <div className="mx-auto flex w-[90%] flex-col items-center justify-center lg:max-w-[1212.8px]">
        <AnimatedTitle
          text={"Digital Garden"}
          className={
            "mb-10 text-left text-[40px] font-bold leading-[0.9em] tracking-tighter text-[#e4ded7] sm:text-[45px] md:mb-16 md:text-[60px] lg:text-[80px]"
          }
          wordSpace={"mr-[14px]"}
          charSpace={"mr-[0.001em]"}
        />

        <div className="mx-auto flex w-[100%] flex-col lg:max-w-[1200px] lg:flex-row lg:gap-20">
          <div className="mb-10 flex w-[100%] flex-col gap-4 text-[18px] font-medium  leading-relaxed tracking-wide text-[#e4ded7] md:mb-16 md:gap-6 md:text-[20px] md:leading-relaxed lg:mb-16  lg:max-w-[90%] lg:text-[24px] ">
            <AnimatedBody text="Once upon a time, in the vast valleys of the digital realm, a tiny being named Grenie was born. While no other fruit or plant could survive in the digital world, Grenie emerged as an energetic fruit that grew at the speed of light. With big curious eyes, Grenie explored every corner, always keeping its head high and smiling through every challenge. Grenie was designed to make people's digital gardens more fun and fruitful." />

            <AnimatedBody
              delay={0.1}
              text="Grenie's special ability is to feed on code and energy. With every new transaction or every block added to the chain, Grenie grows stronger and spreads more energy into the digital ecosystem. It is the joy of the blockchain, the cute gardener of the memecoin world!"
            />

            <AnimatedBody
              delay={0.2}
              text="But Grenie's dream is even bigger: to grow everyone's digital garden and ensure the community has fun together. Its slogan is: “The more you share, the more you grow!” That’s why with every transaction, Grenie gains more friends, and together with them, turns the memecoin world into a greener and more fun place."
            />

            <AnimatedBody
              delay={0.3}
              text="Grenie invites everyone to a friendly competition, to grow their digital gardens and enjoy the new world of finance."
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
